module.exports = __webpack_public_path__ + "static/media/Eventxtra Virtual Platform_v8-12.711a68ae.png";